<template>
  <div class="">
    <el-select ref="brands" v-model="brandId" @change="selectBrand" :filterable="true" :placeholder="brandPlaceholder">
      <el-option
              v-for="item in brands"
              :key="item.name"
              :label="item.name"
              :value="item.id">
      </el-option>
    </el-select>
    <el-select ref="series" v-model="seriesId" @change="selectSeries" :filterable="true" :placeholder="seriesPlaceholder">
      <el-option
              v-for="item in series"
              :key="item.name"
              :label="item.name"
              :value="item.id">
      </el-option>
    </el-select>

    <el-select ref="categories" :multiple="categoriesMultiple" v-model="categoriesIds" @change="selectCategories" :filterable="true" :placeholder="categoriesPlaceholder">
      <el-option
              v-for="item in categories"
              :key="item.name"
              :label="item.namePrice"
              :value="item.id">
      </el-option>
    </el-select>
  </div>

  <!-- /.navbar-static-side -->
</template>

<script>
import Config from '../framework/configs/Config'
import BrandSeriesModel from '../framework/models/brandSeriesModel'
// let provinces = require('../framework/data/area.json');
export default {
  name: 'brand-and-series-categories-select',
  data: function () {
    return {
      baseImageUrl: Config.imageUrl,
      datas: [],
      brandId: null,
      brands: [],
      seriesId: null,
      series: [],
      categories: [],
      categoriesIds: [],
      props: {
        label: 'name',
        value: 'id',
        children: 'datas'
      },
      brandPosition: null,
      seariesPosition: null,
      categoriesPosition: null,
      areaCode: []
    }
  },
  mounted: function () {
    this.loadBrands()
  },
  props: {
    categoriesMultiple: {
      type: Boolean,
      default: true
    },
    brandPlaceholder: {
      type: String,
      default: '请选择品牌'
    },
    seriesPlaceholder: {
      type: String,
      default: '请选择车系'
    },
    categoriesPlaceholder: {
      type: String,
      default: '请选择车型'
    }
  },
  methods: {
    setValue: function (brandId, seriesId, categoryIds) {
      if (brandId) {
        this.brandId = brandId
        this.initSelectBrand(brandId)
      }

      if (seriesId) {
        this.seriesId = seriesId
        this.initSelectSeries(seriesId)
      }

      if (categoryIds) {
        if (this.categoriesMultiple) {
          let ids = categoryIds.split(',')
          let intIds = []

          for (var i = 0; i < ids.length; i++) {
            let id = ids[i]
            intIds.push(parseInt(id))
          }

          this.categoriesIds = intIds
        } else {
          this.categoriesIds = categoryIds
        }
      }
    },
    selectCategories: function (seriesId) {
      // 获取车系信息
      let seriesRef = this.$refs['series']
      let seriesSelected = seriesRef.selected
      let seriesInfo = this.findItemById(seriesSelected.value, this.series)

      // 获取品牌信息
      let brandRefs = this.$refs['brands']
      let selected = brandRefs.selected
      let brandInfo = this.findItemById(selected.value, this.brands)

      let categoriesInfo = null

      if (this.categoriesMultiple) {
        // 获取品牌信息
        let categoriesArr = []

        let categories = this.categories
        let length = categories.length
        let categoriesIds = this.categoriesIds
        for (var i = 0; i < length; i++) {
          let categorie = categories[i]
          let id = categorie['id']
          let position = categoriesIds.indexOf(id)
          if (position != -1) {
            categoriesArr.push(categorie)
          }
        }

        categoriesInfo = categoriesArr
      } else {
        let categoriesRefs = this.$refs['categories']
        let categoriesPosition = categoriesRefs.hoverIndex
        categoriesInfo = this.categories[categoriesPosition]
      }

      if (seriesInfo && brandInfo && categoriesInfo) {
        this.$emit('onChanged', brandInfo, seriesInfo, categoriesInfo)
      }
    },
    initSelectBrand: function (brandId) {
      let _this = this

      if (!brandId) {
        return
      }

      this.series = []
      this.seriesId = null

      this.categories = []
      this.categoriesIds = []

      let params = {
        brandId: brandId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.series = datas
        }
      }
      BrandSeriesModel.findBaseSeriesByBrandIdForCDSystem(_this, params, listener)
    },
    selectBrand: function (brandId) {
      let _this = this

      if (!brandId) {
        return
      }

      this.series = []
      this.seriesId = null

      this.categories = []
      this.categoriesIds = []

      let params = {
        brandId: brandId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.series = datas
        }
      }
      BrandSeriesModel.findBaseSeriesByBrandIdForCDSystem(_this, params, listener)

      // 获取品牌信息

      let brandInfo = this.findItemById(brandId, this.brands)

      if (brandInfo) {
        this.$emit('onChanged', brandInfo)
      }
    },
    initSelectSeries: function (seriesId) {
      this.categories = []
      this.categoriesIds = []

      let _this = this
      let params = {
        seriesId: seriesId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.categories = datas
          for (let i = 0; i < datas.length; i++) {
            let item = _this.categories[i]
            item.namePrice = item.name + '【' + (item.price / 10000) + '万】'
          }
        }
      }
      BrandSeriesModel.getCategoryListBySeriesId(_this, params, listener)
    },
    selectSeries: function (seriesId) {
      this.categories = []
      this.categoriesIds = []

      // 获取车系信息
      let seriesRef = this.$refs['series']
      let position = seriesRef.hoverIndex
      let seriesInfo = this.series[position]

      let _this = this
      let params = {
        seriesId: seriesId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.categories = datas
          for (let i = 0; i < datas.length; i++) {
            let item = _this.categories[i]
            item.namePrice = item.name + '【' + (item.price / 10000) + '万】'
          }
        }
      }
      BrandSeriesModel.getCategoryListBySeriesId(_this, params, listener)

      // //获取品牌信息
      let brandInfo = this.findItemById(seriesInfo.brand_id, this.brands)

      if (seriesInfo && brandInfo) {
        this.$emit('onChanged', brandInfo, seriesInfo)
      }
    },
    findItemById (id, items) {
      let length = items.length
      for (let i = 0; i < length; i++) {
        let item = items[i]
        if (id === item.id) {
          return item
        }
      }
    },
    clear: function () {
      this.areaCode = []
      this.brandPosition = null
      this.seariesPosition = null
      this.seriesId = null
      this.brandId = null
    },
    loadBrands: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.brands = dataInfo.datas
        }
      }
      BrandSeriesModel.findBaseBrandForCDSystem(_this, listener)
    }
  }
}
</script>
